import { BaseSyntheticEvent } from 'react';
import {
  Badge,
  Button,
  Col,
  Container,
  Dropdown,
  Image,
  Row,
} from 'react-bootstrap';
import { useGoogleLogout } from 'react-google-login';
import { AiOutlineUnorderedList } from 'react-icons/ai';
import { FaFileInvoiceDollar, FaUserAlt, FaUserCircle } from 'react-icons/fa';
import { IoIosWallet } from 'react-icons/io';
import { RiLogoutBoxFill } from 'react-icons/ri';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
import logo from '../assets/logo_stride.png';
import ForgotPasswordModal from '../components/modal/forgot-password-modal/forgot-password-modal.component';
import LoginModal from '../components/modal/login-modal/login-modal.component';
import SignupByEmailModal from '../components/modal/signup-by-email-modal/signup-by-email-modal.component';
import SignupModal from '../components/modal/signup-modal/signup-modal.component';
import { configService } from '../config/configureApi';
import { AuthActionEnum } from '../enums/app.enum';
import { useAuthState } from '../states/auth.state';
import { useModalState } from '../states/modal.state';
import { privateRoutes } from '../template/routes';
import './SHeader.scss';

const GOOGLE_API_KEY = configService.googleLoginApiKey || '';

const SHeader = () => {
  const history = useHistory();
  const authState = useAuthState();
  const { url } = useRouteMatch();
  const modalState = useModalState();

  const openLoginModal = () => {
    // setShow(true)
    modalState.showModal('showLogin');
  };

  const openSignupModal = () => {
    // setShowSignup(true)
    modalState.showModal('showSignUp');
  };

  const { signOut } = useGoogleLogout({
    clientId: GOOGLE_API_KEY,
    onLogoutSuccess: () => {},
    onFailure: () => {},
  });

  const handleLogout = (e: BaseSyntheticEvent) => {
    e.preventDefault();
    authState.logout();
    signOut();
    privateRoutes.find((item) => item.path === url);
    history.push('/');
  };

  const handleCloseLogin = (data: string) => {
    if (data == AuthActionEnum.OPEN_SIGNUP) {
      modalState.showModal('showSignUp');
    } else if (data == AuthActionEnum.OPEN_FORGOT) {
      modalState.showModal('showForgot');
    } else {
      modalState.setValue('showLogin', false);
    }
  };

  const handleCloseSignup = (data: any) => {
    if (data == AuthActionEnum.OPEN_SIGN_UP_BY_EMAIL) {
      modalState.showModal('showSignUpByEmail');
    } else if (data == AuthActionEnum.OPEN_LOGIN) {
      modalState.showModal('showLogin');
    } else {
      modalState.setValue('showSignUp', false);
    }
  };

  const handleCloseForgot = (data: any) => {
    if (data == AuthActionEnum.OPEN_LOGIN) {
      modalState.showModal('showLogin');
    } else {
      modalState.setValue('showForgot', false);
    }
  };

  const handleCloseSignupByEmail = (data: string) => {
    if (data == AuthActionEnum.OPEN_LOGIN) {
      modalState.showModal('showLogin');
    } else {
      modalState.setValue('showSignUpByEmail', false);
    }
  };

  return (
    <header className="s-header">
      <div className="bg-dark text-white">
        <Container>
          <p className="p-0 m-0">
            <a
              href="tel:+6564775977"
              className="text-white text-decoration-none"
            >
              CONTACT (+65) 6477 5977
              
            </a>
          </p>
        </Container>
      </div>
      <div>
        <Container>
          <Row className="align-items-center py-2">
            <Col
              className="px-0 text-center text-md-left flex-grow-0"
              xs={6}
              md={5}
            >
              <Link to="/">
                <Image src={logo} className="image-logo w-100" />
              </Link>
            </Col>
            <Col className="px-0 ml-auto text-right" xs={6} md={7}>
              <Button
                variant="danger"
                className="fw-6 letter-86 radius-20 py-2 px-4 mr-2 d-none d-sm-inline-block"
                onClick={(e) => history.push('/')}
              >
                Book Now
              </Button>
              {authState.get().currentUser ? (
                <div className="d-inline">
                  <Dropdown className="d-inline-block">
                    {authState.get().outstandingBookings.length ? (
                      <Badge
                        pill
                        variant="danger"
                        className="outstanding-badge"
                      >
                        {authState.get().outstandingBookings.length}
                      </Badge>
                    ) : (
                      <></>
                    )}
                    <Dropdown.Toggle
                      variant="outline-secondary"
                      className="p-0 pl-3 s-button s-button-fullname"
                    >
                      <span className="header-username">
                        {authState.get().currentUser?.display_name}
                      </span>
                      {authState.get().currentUser &&
                      authState.get().currentUser?.pic ? (
                        <Image
                          src={authState.get().currentUser?.pic}
                          roundedCircle
                          width={40}
                          height={40}
                          className="ml-2"
                          style={{ backgroundColor: '#CFCDCE' }}
                        />
                      ) : (
                        <FaUserCircle
                          className="ml-2"
                          size={40}
                          style={{ color: '#C4C4C4' }}
                        />
                      )}
                    </Dropdown.Toggle>

                    <Dropdown.Menu align="left">
                      {authState.get().outstandingBookings.length ? (
                        <>
                          <Dropdown.Item
                            size="sm"
                            onClick={(e) => history.push('/user-outstanding')}
                          >
                            <FaFileInvoiceDollar className="mr-1 mt-n1" />{' '}
                            Outstanding amount (
                            {authState.get().outstandingBookings.length})
                          </Dropdown.Item>
                        </>
                      ) : (
                        <></>
                      )}
                      <Dropdown.Item
                        size="sm"
                        onClick={(e) => history.push('/user-profile-setting')}
                      >
                        <FaUserCircle className="mr-1 mt-n1" /> Profile Settings
                      </Dropdown.Item>
                      <Dropdown.Item
                        size="sm"
                        onClick={(e) => history.push('/user-billing')}
                      >
                        <IoIosWallet className="mr-1 mt-n1" /> Billing
                      </Dropdown.Item>
                      <Dropdown.Item
                        size="sm"
                        onClick={(e) => history.push('/user-manage-booking')}
                      >
                        <AiOutlineUnorderedList className="mr-1 mt-n1" /> Manage
                        Booking
                      </Dropdown.Item>
                      <Dropdown.Item size="sm" onClick={handleLogout}>
                        <RiLogoutBoxFill className="mr-1 mt-n1" /> Sign out
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  {/* <Button variant="outline-secondary" className="s-button border-0 s-button-fullname" onClick={handleLogout}>{authState.get().currentUser?.display_name}</Button> */}
                </div>
              ) : (
                <div className="d-inline-block">
                  <Button
                    variant="outline-secondary"
                    className="s-button mr-2"
                    onClick={openSignupModal}
                  >
                    SIGN UP
                  </Button>
                  <Button
                    variant="outline-secondary"
                    className="s-button"
                    onClick={openLoginModal}
                  >
                    LOGIN <FaUserAlt />
                  </Button>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>

      {modalState.get().showLogin && (
        <LoginModal
          show={modalState.get().showLogin}
          onHide={handleCloseLogin}
          pathto={modalState.get().pathto}
        />
      )}
      {modalState.get().showSignUp && (
        <SignupModal
          show={modalState.get().showSignUp}
          onHide={handleCloseSignup}
          pathto={modalState.get().pathto}
        />
      )}
      {modalState.get().showForgot && (
        <ForgotPasswordModal
          show={modalState.get().showForgot}
          onHide={handleCloseForgot}
        />
      )}
      {modalState.get().showSignUpByEmail && (
        <SignupByEmailModal
          show={modalState.get().showSignUpByEmail}
          onHide={handleCloseSignupByEmail}
        />
      )}
    </header>
  );
};

export default SHeader;
